import { configureStore } from "@reduxjs/toolkit";
import bookingReducer from "./bookingSlice";
import signupReducer from "./signupSlice";
// import { comp } from 'redux-devtools-extension';

export const store = configureStore({
  reducer: {
    booking: bookingReducer,
    signup: signupReducer,
  },
});
